<script>
  /**
   * Specify title color
   * @type {"foreground-1" | "accent-1-contrast"}
   */
  export let color = 'foreground-1';

  /**
   * Specify max-width in characters
   * @type {number}
   */
   export let max = '';
</script>

<h1 class="color-{color}">
  <span style="{max ? 'max-width:' + max + 'ch;' : undefined}">
    <slot></slot>
  </span>
</h1>

<style>
  h1 {
    position: relative;
    z-index: 1;
    margin: 0;
    padding-top: 4rem;
    padding-bottom: 4rem;
    text-align: center;
    font-size: calc(2.25rem + 1vw);
    font-family: var(--ff-2);
    font-weight: normal;
  }

  span {
    display: inline-block;
  }
  
  .color-foreground-1 {
    color: var(--fg-1);
  }

  .color-accent-1-contrast {
    color: var(--a1-c);
  }
</style>